import {
  GET_NOTIFS,
  GET_UNREAD_COUNT,
  MARK_NOTIF_AS_READ,
  MARK_ALL_AS_READ,
} from "../../actions/notifications/notifications";

const initialState = {
  notifications: [],
  unreadCount: 0,
};

export default function notifications(state = initialState, action) {
  switch (action.type) {
    case GET_NOTIFS:
      return {
        ...state,
        notifications: action.notifications,
        unreadCount: action.notifications.filter((n) => !n.is_read).length,
      };

    case GET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.count,
      };

    case MARK_NOTIF_AS_READ:
      return {
        ...state,
        notifications: state.notifications.map((notif) =>
          notif._id === action.notifId ? { ...notif, is_read: true } : notif,
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      };

    case MARK_ALL_AS_READ:
      return {
        ...state,
        notifications: state.notifications.map((notif) => ({
          ...notif,
          is_read: true,
        })),
        unreadCount: 0,
      };

    default:
      return state;
  }
}
